module.exports = __webpack_public_path__ + "media/images/donate/twint-qr-code-ff6186f086a93aca96730d26691a7d1b.jpg";